import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';

import { HttpClientService } from './http-client.service';
import type { EmailResolutionResponsesClient } from '../tokens/email-resolution-responses-client.token';
import type { EmailResolutionResponseItem } from '../../features/email-response/models/email-response.model';
import { EMAIL_RESOLUTION_RESPONSES } from '../../shared/constants/api-routes.constants';

@Injectable({ providedIn: 'root' })
export class EmailResolutionResponsesService implements EmailResolutionResponsesClient {
  private readonly http = inject(HttpClientService);

  getEmailResolutionResponses(): Observable<EmailResolutionResponseItem[]> {
    return this.http.get<EmailResolutionResponseItem[]>(EMAIL_RESOLUTION_RESPONSES.BASE);
  }
}
